import styled from "styled-components";
import { Spinner } from "pro-features/components/Loaders/src/Spinner";

const LoaderWrapper = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const LoadingSpinner = styled(Spinner)<{ top?: string }>`
    margin: 0 auto;
    position: relative;
    width: 46px;
    height: 46px;
`;

export const IndustryOverviewLoader = () => {
    return (
        <LoaderWrapper>
            <LoadingSpinner />
        </LoaderWrapper>
    );
};
